<template>
  <div class="desc-container">
    <div class="desc-inner-container">
      <div class="text">
        <span v-if="descTexts">
          <div v-for="item in descTexts">{{item}}</div>
        </span>
        <span v-else>
          {{descText}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['desc'],
    data () {
      if (typeof this.desc === 'object' && this.desc.constructor === Array) {
        return {
          descText:'',
          descTexts: this.desc
        };
      }
      return {
        descText: this.desc,
        descTexts: null
      };
    }
  };
</script>

<style lang="less">
  .desc-container {
    background: white;
    .desc-inner-container {
      padding: 10px 22px 15px 20px;
      .text {
        background: #F8F8F8;
        min-height: 40px;
        line-height: 40px;
        padding-left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DescText.vue?6e0a9978